__turbopack_context__.v({
  "actions": "O6KOfq_actions",
  "body": "O6KOfq_body",
  "content": "O6KOfq_content",
  "discardBtn": "O6KOfq_discardBtn",
  "keepBtn": "O6KOfq_keepBtn",
  "title": "O6KOfq_title",
});
